import { z } from 'zod';
import { ValuationMethod } from '../enums.js';
import { IsoDate, MoneyAmount, UuidString } from '../primitives.js';

/**
 * S13-BE.1 — COGS report DTO (computed, не persisted за исключением snapshot).
 * Агрегат из cost-engine для регуляторной финансовой отчётности (КПН, P&L).
 */

export const CogsReportPeriod = z.object({
  date_from: IsoDate,
  date_to: IsoDate,
});
export type CogsReportPeriod = z.infer<typeof CogsReportPeriod>;

export const CogsReportRow = z.object({
  period: CogsReportPeriod,
  item_id: UuidString,
  item_sku: z.string(),
  item_name_ru: z.string(),
  item_name_kk: z.string().nullable(),
  qty_sold: MoneyAmount,
  cogs_amount: MoneyAmount,
  avg_cost_per_unit: MoneyAmount,
  valuation_method: ValuationMethod,
  work_order_refs: z.array(UuidString),
});
export type CogsReportRow = z.infer<typeof CogsReportRow>;

export const CogsReport = z.object({
  period: CogsReportPeriod,
  rows: z.array(CogsReportRow),
  totals: z.object({
    qty_sold: MoneyAmount,
    cogs_amount: MoneyAmount,
  }),
  schema_version: z.string(),
});
export type CogsReport = z.infer<typeof CogsReport>;
